import { applicationConsumer } from '../applicationConsumer.js';
import { setLoading } from '../loading.js';

export function initialize(store) {
  applicationConsumer.subscriptions.create(
    { channel: 'JobStatusChannel' },
    {
      received: (data) => {
        const { status, name } = data;
        const loadingId = `job:${name}`;
        if (status === 'in_progress') {
          setLoading(store, loadingId, true);
        } else if (status === 'completed' || status === 'error') {
          setLoading(store, loadingId, false);
          if (status === 'error') {
            console.error(`Job ${name} failed: ${data.error}`);
          } else if (status === 'completed') {
            window.location.reload();
          }
        }
      },
    }
  );
}
